export default __webpack_public_path__ + "static/media/History.c857c764.jpg";